import React from 'react';


import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import configureStore from 'client/store/configureStore';
import Layout from "client/components/Layout";
 
import CssBaseline from '@mui/material/CssBaseline';
 

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

export default class Client extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {

        return (
        
            <Provider store={store}>
              
                <ConnectedRouter history={history}>
                    <div>
                       
                        <CssBaseline />
                        
                        <Layout loginStatusAction={this.props.loginStatusAction} logoutStatusAction={this.props.logoutStatusAction}/>
                        
                    </div>
                </ConnectedRouter>
                </Provider>
           
        );

    }

} 